<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title">Adicionar Questão</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="affiliationForm" (ngSubmit)="save()">
    <div class="modal-body">
      <div class="form-group">
        <label for="magazine">Área de Conhecimento</label>
        <!-- <ng-select [items]="periodic$ | async"
          bindLabel="name"
          [addTag]="false"
          [multiple]="true"
          [hideSelected]="true"
          [trackByFn]="trackByFn"
          [minTermLength]="2"
          [loading]="periodicLoading"
          typeToSearchText="Digite 2 ou mais caracteres"
          [typeahead]="periodicInput$"
          [(ngModel)]="selectedPeriodics"
          [ngModelOptions]="{standalone: true}">
        </ng-select> -->
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-link" (click)="activeModal.dismiss()">Voltar</button>
      <button type="submit" [attr.data-loader]="!submitted" btnloader class="btn btn-primary">
        Salvar
      </button>
    </div>
  </form>
</div>
